import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { BaseComponent } from '@shared/component/base/base.component';
import { FinancialYear, FinancialYearService, User } from 'taxtank-core';

// todo: rename to app-financial-year-select
@Component({
  selector: 'app-year-chooser',
  templateUrl: './year-chooser.component.html',
  styleUrls: ['./year-chooser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class YearChooserComponent extends BaseComponent implements OnInit {
  private financialYearService = inject(FinancialYearService);
  lastFinYear = FinancialYear.toFinYear(new Date());
  isCurrentFinancialYear: boolean;

  @Input() user: User;

  ngOnInit(): void {
    this.isCurrentFinancialYear = this.user.isCurrentFinancialYear();
  }

  switch(year: number): void {
    this.financialYearService.switch(year).subscribe();
  }
}
